var urlProtocolRegex = /(^http[s]*:\/\/)|(^mailto:)/;
var urlProtocolMatch = /^http[s]?[:]?\/*/;
var emailRegex = /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
var hasProtocol = function hasProtocol(value) {
  return urlProtocolRegex.test(value);
};
var isEmail = function isEmail(value) {
  return emailRegex.test(value);
};
module.exports = function webLinkUrlFormat() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  // Leave it alone if it is empty or already starts with a protocol
  if (!value || hasProtocol(value)) {
    return value;
  }

  // Match incorrect http, http:, http:/+...
  var match = value.match(urlProtocolMatch);
  if (match && match[0]) {
    var startAt = match[0].length;
    var protocol = "http".concat(value.substr(0, startAt).indexOf('s') > -1 ? 's' : '', "://");
    return "".concat(protocol).concat(value.substr(startAt));
  }

  // Add mailto: for emails that are passed in
  if (isEmail(value)) {
    return "mailto:".concat(value);
  }

  // Prefix with a default http
  return "http://".concat(value);
};